import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import createActionHandler from "@web-monorepo/infra/createActionHandler";
import createAsyncActions from "@web-monorepo/infra/createAsyncActions";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import createApiSaga from "src/utils/createApiSaga";

const STATE_KEY = "npsSurvey";

type State = {
  submitted: boolean | null;
};

const initialState: State = {
  submitted: null,
};

// Actions
const [SUBMIT_NPS_SURVEY, SUBMIT_NPS_SURVEY_DONE, SUBMIT_NPS_SURVEY_FAIL] = createAsyncActions(
  `${STATE_KEY}/submitNpsSurvey`,
);

// Action Creators
export function submitNpsSurvey(score: number, comment: string) {
  return {
    type: SUBMIT_NPS_SURVEY,
    payload: {
      score,
      comment,
    },
  };
}

// Sagas
const submitNpsSurveyApiSaga = createApiSaga(
  SUBMIT_NPS_SURVEY,
  ({ score, comment }: { score: number; comment: string }) => {
    return {
      method: "POST",
      path: "/api/parentNpsSurveyResponse",
      body: { score, comment },
    };
  },
  SUBMIT_NPS_SURVEY_DONE,
);

// Reducers
const submitNpsSurveyHandler = createActionHandler(
  SUBMIT_NPS_SURVEY,
  () =>
    (state: State): State => ({
      ...state,
      submitted: true,
    }),
);

const submitNpsSurveyFailHandler = createActionHandler(
  SUBMIT_NPS_SURVEY_FAIL,
  () =>
    (state: State): State => ({
      ...state,
      submitted: false,
    }),
);

// Final reducer
const finalReducer = combineActionHandlers(initialState, [submitNpsSurveyHandler, submitNpsSurveyFailHandler]);

const install: PodInstallFunction = (installReducer, installSaga) => {
  installReducer(STATE_KEY, finalReducer);
  installSaga(submitNpsSurveyApiSaga);
};

export default install;
